import { useFarmContext } from 'src/Elements/Farm'

/**
 * This hook provides a list of a farm clients if it its the farm master,
 * otherwise it returns the client or single storage id in one item list
 */
export const useStorageIdList = (storageId?: string): string[] => {
  const { isFarm, farmClients, isFarmMasterSelected } = useFarmContext()
  if (!storageId) return []
  if (isFarm && isFarmMasterSelected) {
    return farmClients?.map(client => client.storageId) ?? []
  } else {
    return [storageId]
  }
}

/**
 * This hook is an alternative for useStorageIdList for cases savings data is required.
 * The savings for specific clients are missing currently, so we can only get the data of the whole installation.
 * Whenever the specific data is made available for clients, this hook can be replaced with useStorageIdList again.
 *
 * @param storageId
 * @returns
 */
export const useStorageListForMissingFarmData = (storageId?: string): string[] => {
  const { isFarm, farmClients, farmMaster } = useFarmContext()
  if (!storageId) return []

  if (isFarm && farmMaster?.storageId) {
    return [farmMaster.storageId, ...(farmClients?.map(client => client.storageId) || [])]
  } else {
    return [storageId]
  }
}
